module.exports = __webpack_public_path__ + "static/media/close.154ca518.svg";